class WoodShapesComponent extends HTMLElement {

  constructor() {
    super();
    this.shapeType = 'lumber-shape'
    
    this.shapeFiles = {      
      'lumber-shape': 'Wood/Lumber.json',
      'trus-joist-shape': 'engineered-lumber/trus-joist-shapes.json',
      'other-vendors-east-joist-shape': 'engineered-lumber/other-vendors-east-shapes.json',
      'other-vendors-west-joist-shape': 'engineered-lumber/other-vendors-west-shapes.json'
    }

    document.addEventListener('wood-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }

  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  onShapeFileClick(id) {
    this.shapeType = id
    if(id === 'lumber-shape') {
      getWoodShapes(this.shapeFiles[id])
    } else {
      getEngineeredLumberShapes(this.shapeFiles[id])
    }
    // reset buttons
    this.resetButton('lumber-shape')
    this.resetButton('trus-joist-shape')
    this.resetButton('other-vendors-east-joist-shape')
    this.resetButton('other-vendors-west-joist-shape')
    document.getElementById(id).classList.add('btn-primary')
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div>
      <button class="btn btn-default button-shadow" id='lumber-shape'>Lumber</button>
      <button class="btn btn-default button-shadow" id='trus-joist-shape'>TrusJoist</button>
      <button class="btn btn-default button-shadow" id='other-vendors-east-joist-shape'>Other Vendors (east)</button>
      <button class="btn btn-default button-shadow" id='other-vendors-west-joist-shape'>Other Vendors (west)</button>
    </div>

    <div style="margin:10px;" class="text-left">
      <div id="ply-selector-group" class="form-group">
        <label for="exampleFormControlSelect1">Number of Plys</label>
        <select id="ply-selector" class="form-control" onchange="onPlySelectorChange()">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
        </select>
      </div>
    </div>
    `

    document.getElementById('lumber-shape').onclick = (() => this.onShapeFileClick('lumber-shape'))
    document.getElementById('trus-joist-shape').onclick = (() => this.onShapeFileClick('trus-joist-shape'))
    document.getElementById('other-vendors-east-joist-shape').onclick = (() => this.onShapeFileClick('other-vendors-east-joist-shape'))
    document.getElementById('other-vendors-west-joist-shape').onclick = (() => this.onShapeFileClick('other-vendors-west-joist-shape'))
    
    this.onShapeFileClick('lumber-shape')
  }
}

customElements.define('wood-shape-selector-component', WoodShapesComponent)

